// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__Ol2kZ","wrapper":"SectionTitle_wrapper__Ch1Nm"};